import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

document.addEventListener('click', async (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('[data-plp-add]');
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  event.preventDefault();
  event.stopPropagation();

  const card = button.closest('product-card');
  const checked = card?.querySelector('input[type="radio"][data-variant-id]:checked');
  const variantId =
    checked?.getAttribute('data-cart-variant-id') ||
    button.dataset.cartVariantId ||
    checked?.getAttribute('data-variant-id') ||
    button.dataset.variantId;
  if (!variantId) return;

  const quantity = button.dataset.quantity || '1';
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);

  const sectionIds = [];
  document.querySelectorAll('cart-items-component').forEach((item) => {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      sectionIds.push(item.dataset.sectionId);
    }
  });
  if (sectionIds.length) {
    formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);
  }

  button.classList.add('is-adding');
  button.disabled = true;

  try {
    const fetchCfg = fetchConfig('javascript', { body: formData });
    const response = await fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: {
        ...fetchCfg.headers,
        Accept: 'text/html',
      },
    });
    const data = await response.json();

    if (data.status) {
      return;
    }

    button.dispatchEvent(
      new CartAddEvent({}, variantId, {
        source: 'product-form-component',
        itemCount: Number(quantity) || 1,
        productId: button.dataset.productId,
        sections: data.sections,
      })
    );
  } catch (error) {
    console.error(error);
  } finally {
    button.classList.remove('is-adding');
    button.disabled = false;
  }
});
